mutation saveEmproSelectedContactStatuses($input: EmproSelectedContactStatusesInput!) {
    config: saveEmproSelectedContactStatuses(input: $input) {
        isTokenVerified
        selectedContactStatusIds
    }
}
